export interface HeaderProps {
  /** Accepted for the callers in RulesView and HelpView; nothing renders it any more. */
  onClose?: () => void;
}

/**
 * Renders nothing. The X button was removed once the navigation bar became the
 * topmost element; RulesView and HelpView still render this placeholder.
 */
export default function Header({ onClose }: HeaderProps = {}) {
  return null;
}
